/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ago: NonNullable<unknown> }} Metastartedprefix2Inputs */

const en_metastartedprefix2 = /** @type {(inputs: Metastartedprefix2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`started ${i?.ago}`)
};

const pt_metastartedprefix2 = /** @type {(inputs: Metastartedprefix2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`iniciado ${i?.ago}`)
};

/**
* | output |
* | --- |
* | "started {ago}" |
*
* @param {Metastartedprefix2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const metastartedprefix2 = /** @type {((inputs: Metastartedprefix2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metastartedprefix2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metastartedprefix2(inputs)
	return pt_metastartedprefix2(inputs)
});
export { metastartedprefix2 as "metaStartedPrefix" }